import React from 'react';
import {theme} from '../../App.jsx';
import TextField from '@mui/material/TextField';
import {variant, margin} from '../../constants/form';

export default function Select({
                                   name,
                                   label,
                                   formData,
                                   errors,
                                   initialData = {},
                                   optionsOverride,
                                   formValidations,
                                   handleFieldChange
                               }) {

    const options = optionsOverride || initialData[name] || [];

    return (
        <TextField
            InputProps={{sx: {borderRadius: 4, background: "white"}}}
            //size="small"
            variant={variant}
            margin={margin}
            fullWidth
            select
            SelectProps={{native: true}}
            label={label}
            name={name}
            value={formData[name]}
            onChange={handleFieldChange}
            error={!!errors[name]}
            helperText={errors[name]}
            required={formValidations[name]?.required}
            sx={{
                '& .MuiOutlinedInput-notchedOutline': {
                    borderColor: theme.palette.primary.main
                },
            }}
        >
            <option value=""></option>
            {options.map((each) => (
                <option key={each.id} value={each.id}>
                    {each.nombre}
                </option>
            ))}
        </TextField>
    )
}
